import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/App.jsx';
import { BrowserRouter as Router } from 'react-router-dom';
import { Main } from './pages/main/Main.jsx';


const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<Router basename='/'><Main /></Router>);